'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _zh_CN = require('./zh_CN');

var _zh_CN2 = _interopRequireDefault(_zh_CN);

var _zy_CN = require('./zy_CN');

var _zy_CN2 = _interopRequireDefault(_zy_CN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
exports.default = {
  zh_CN: _zh_CN2.default,
  zy_CN: _zy_CN2.default
};